import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Input, Button, FormGroup, Label } from 'reactstrap';
import Select, { components } from 'react-select';
import { toast } from 'react-toastify';
import { cloneDeep, findIndex, union, uniqBy } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import { baseUrl, payment_method } from '../../constants/environment';
import styled from 'styled-components';
import TextUtils from '../../helpers/TextUtils';
import NumberFormat from 'react-number-format';
import AsyncSelect from "react-select/async";
import { RenderActionModal, StatusList } from './StockReturnList';
import { PaymentMethodList } from '../designation/DesignationAdd';
import BatchAdd from '../batch/BatchAdd';
import queryString from 'query-string';
import PaymentAdd from '../payment/PaymentAdd';
import SupplierList from '../supplier/SupplierList';
import ProductUtil from '../../helpers/ProductUtil';
import moment from 'moment';
import MessageManager from '../../manager/MessageManager';
import { RenderActionModal as RenderActionOrderModal } from '../order/OrderList';

export const DiscountType:any = [
    {
        value:'price',
        label: "Giá trị"
    },
    {
        value:'percent',
        label: "%"
    },
]
interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}

const Detail = (props: any) => {
    const {from,dataFromExam, setDataFromExam, closeModal, fetchCustomerExam} = props
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(props?.match?.params?.id);
    const [onlyView, setOnlyView] = useState(false);
    const [data, setData] = useState<any>({
        branch_id: props?.user?.branch_id?.id,
        discount_type: 'price'
    });
    const [product, setProduct] = useState<any>([{
        product_id: "",
        quantity:"",
        unit_id:"",
    }])
    const [vnpayTerminal, setVNPayTerminal] = useState<any>([]);
    const [productByImport, setProductByImport] = useState<any>()
    const [productTemplate, setProductTemplate] = useState<any>()
    const [stockImportTemplate, setStockImportTemplate] = useState<any>()
    const [modalIsOpen, setIsOpen] = useState(false);
    const [type, setType] = useState(props?.match?.params?.action);
    const [action, setAction] = useState<any>();
    const [branch, setBranch] = useState<any>([]);
    const [supplier, setSupplier] = useState<any>([]);
    const [supplierInfo, setSupplierInfo] = useState<any>();
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [payment, setPayment] = useState<any>([{
        product_id: "",
        quantity:"",
    }])
    const [history, setHistory] = useState<any>();
    const [validation, setValidation] = useState<any>({})
    const router = useHistory()
    const [paymentSynce, setPaymentSynce] = useState<any>([]);
    const paymentSynceRef = useRef<any>(null);
    const searchPrams = queryString.parse(props.location.search)

    const loadHistory = async (id:number) => {
        const url = `${baseUrl}/stock/return/history/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response?.data;
            setHistory(resData)
        }
    }

    useEffect(() => {
        paymentSynceRef.current = paymentSynce
      }, [paymentSynce]);

    useEffect(() => {
        MessageManager.addListener({
            onUpdatePaymentStatusStockReturn,
        });
        return () => {
          MessageManager.removeListener("onUpdatePaymentStatusStockReturn");
        };
      }, []);
    
    const onUpdatePaymentStatusStockReturn = (dataPayment: any) => {
        const clonePaymentSynce:any = cloneDeep(paymentSynceRef?.current)
        const newPaymentSynce = clonePaymentSynce?.reduce((prev:any, item:any)=>{
          if(item?.id === dataPayment?.id){
            if(item.status !== dataPayment.status){
                if(item.status === 1) toast.success(`Phiếu thu ${item?.code} vừa nhận được thanh toán: ${PriceUtils.format(item?.payment_total, ' đ')}`)
                if(item.status === -1) toast.success(`Phiếu thu ${item?.code} chuyển trạng thái thất bại`)
            }
            item.status = dataPayment?.status
          }
          prev = [...prev, item]
          return prev
        },[])
        setPaymentSynce(newPaymentSynce)
    };

    useEffect(() => {
        if (id && id !== 'add') {
            loadData(id)
            document.title = 'Chỉnh sửa phiếu trả hàng'
            
        }else{
            document.title = 'Thêm mới phiếu trả hàng'
        }
        if (type === 'view') {
            setOnlyView(true)
            loadHistory(id)
            document.title = 'Chi tiết phiếu trả hàng'
        }
    }, [id]);

    useEffect(() => {
        if (searchPrams?.stockimport_id) setData({
            ...data,
            stock_import_id: searchPrams?.stockimport_id
        })
    }, [searchPrams?.stockimport_id]);

    useEffect(() => {
        if (data?.stock_import_id && (!id || (id && id === 'add'))) {
            loadDataByStockImport(Number(data?.stock_import_id))
        }
    }, [data?.stock_import_id]);

    useEffect(() => {
            const ids = data?.stock_import_ids?.reduce((prev:any, item:any)=>{
                prev = [...prev, item?.id]
                return prev
            },[])
            loadDataByStockImports(ids)
    }, [data?.stock_import_ids]);

    useEffect(() => {
        loadImport()
    }, [data?.supplier_id]);

    useEffect(() => {
        validationFrom(false)
    }, [productByImport, product]);
    
    useEffect(() => {
        loadInit()
    }, []);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }
    
    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 200,
        }
        const [
            responseBranch,
            responseProductTemplate,
            responseSupplier,
            responsePaymentMethod,
            responseVNPayTerminal
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/branch`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/product`, {...params, limit: 10}),
            APIClient.GET(`${baseUrl}/supplier`, params),
            APIClient.GET(`${baseUrl}/payment-method`, {
                ...params,
                include_vnpay: true
            }),
            APIClient.GET(`${baseUrl}/vnpay-terminal`, {
                ...params,
                branch_id: props?.user?.branch_id?.id,
            }),
        ]);
        if (responsePaymentMethod.response?.data !== undefined) {
            let ListArr:any = [];
            responsePaymentMethod.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setPaymentMethod(ListArr)
        }
        if (responseBranch.response?.data !== undefined) {
            let ListArr:any = [];
            responseBranch.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setBranch(ListArr)
        }
        if (responseProductTemplate.response?.data !== undefined) {
            const ListArr = ProductUtil.parseProduct(responseProductTemplate.response?.data)
            setProductTemplate(ListArr)
        }
        if (responseSupplier.response?.data !== undefined) {
            let ListArr:any = [];
            responseSupplier.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setSupplier(ListArr)
        }
        if (responseVNPayTerminal.response?.data !== undefined) {
            let ListArr:any = [];
            responseVNPayTerminal.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setVNPayTerminal(ListArr)
        }
    }

    const loadImport = async () => {
        const params = {
            page:1,
            supplier_id: data?.supplier_id,
            status: 2,
            limit: 200,
        }
        const [
            responseStockImport,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/stock/import`, {
                ...params,
            }),
        ]);
        if (responseStockImport.response?.data !== undefined) {
            let ListArr:any = [];
            responseStockImport.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.code
                })
            })
            setStockImportTemplate(ListArr)
        }
    }

    const loadData = async (id:number) => {
        const url = `${baseUrl}/stock/return/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const resDataProduct = response.response?.stock_return_products?.reduce((prev:any, item:any)=>{
                const product_units_lockup:any = {}
                product_units_lockup['root'] = {
                    name: item?.product_id?.minimum_unit,
                    quantity_conversion: 1,
                }
                item?.product_id?.product_units?.map((itemUnit:any)=>{
                    product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
                })
                const product_variants = item?.product_id?.product_variants
                const product_variants_units:any = ProductUtil.parseProductUnit(item?.product_id, product_variants, product_units_lockup)
                let itemRoot = {
                    name: item?.product_id?.name,
                    sku: item?.product_id?.sku,
                    stock_max: item?.product_id?.stock_max,
                    stock_min: item?.product_id?.stock_min,
                    type: item?.product_id?.type,
                    status: item?.product_id?.status,
                    height: item?.product_id?.height,
                    weight: item?.product_id?.weight,
                    width: item?.product_id?.width,
                    longs: item?.product_id?.longs,
                    vat: item?.product_id?.vat,
                    price: item?.product_id?.price,
                    price_import: item?.product_id?.price_import,
                    price_wholesale: item?.product_id?.price_wholesale,
                    product_id: item?.product_id?.id,
                    variant_id: null,
                    value: `${item?.id}`,
                    label: item?.product_id?.name,
                    units: product_variants_units,
                    batchs: ProductUtil.parseProductBatch(item?.product_id?.product_batchs || [])
                }
                if(item?.variant_id){
                    const itemVariant = item?.variant_id
                    const product_variants_units:any = ProductUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                    itemRoot = {
                        ...itemRoot,
                        name: itemVariant?.name,
                        sku: itemVariant?.sku,
                        vat: itemVariant?.vat,
                        price: item?.price,
                        price_import: itemVariant?.price_import,
                        price_wholesale: itemVariant?.price_wholesale,
                        product_id: item?.id,
                        variant_id: itemVariant?.id,
                        value: `${item?.id}-${itemVariant?.id}`,
                        label: itemVariant?.name,
                        units: product_variants_units,
                        batchs: ProductUtil.parseProductBatch(itemVariant?.product_batchs || [])
                    }
                }
                prev = [...prev, {
                    product_id: item?.product_id?.id,
                    variant_id: item?.variant_id?.id,
                    product: itemRoot,
                    quantity: item?.quantity,
                    quantity_request: item?.quantity_request,
                    price: item?.price,
                    price_request: item?.price_request,
                    discount: item?.discount,
                    unit_id: item?.unit_id?.id || 0,
                    batch_id: item?.batch_id?.id || 0,
                }]
                return prev
            },[]);
            const dataTemp:any = {
                ...resData,
                branch_id: resData.branch_id?.id,
                supplier_id: resData.supplier_id?.id,
                stock_import_id: resData.stock_import_id?.id,
                stock_import_ids: resData.stock_import_ids?.reduce((prev:any, item:any)=>{
                    prev = [...prev, {
                        ...item,
                        value: item?.id,
                        label: item?.code,
                    }]
                    return prev
                },[]),
            }
            console.log("dataTemp", dataTemp)
            setData(dataTemp)
            setProduct(resDataProduct)
            setPayment(resData?.stock_return_payments?.reduce((prev:any, item:any)=>{
                prev = [...prev,{
                    ...item,
                    payment_method_id: item?.payment_method_id?.id,
                    vnpay_terminal_id: item?.vnpay_terminal_id?.id,
                }]
                return prev
            },[]))
            setSupplierInfo(resData.supplier_id)
        }
    }

    const loadDataByStockImport = async (id:number) => {
        const url = `${baseUrl}/stock/import/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const dataTemp:any = {
                ...resData,
                status: undefined,
                code: null,
                branch_id: resData.branch_id?.id,
                supplier_id: resData.supplier_id?.id,
                stock_import_id: id,
                stock_import_ids: [{
                    ...resData,
                    label: resData?.code,
                    value: resData?.id,
                }],
            }
            setData(dataTemp)
            setSupplierInfo(resData.supplier_id)
            loadDataByStockImports([id], true)
        }
    }

    const loadDataByStockImports = async (ids:any, autoFill?:boolean) => {
        if(!ids) {
            setProductByImport([])
            if(autoFill) setProduct([])
        }
        const url = `${baseUrl}/stock/import/product`;
        setLoading(true)
        let response: any = await APIClient.GET(url, {
            import_ids: ids
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resDataProduct = response.response?.reduce((prev:any, item:any)=>{
                const product_units_lockup:any = {}
                product_units_lockup['root'] = {
                    name: item?.product_id?.minimum_unit,
                    quantity_conversion: 1,
                }
                item?.product_id?.product_units?.map((itemUnit:any)=>{
                    product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
                })
                const product_variants = item?.product_id?.product_variants
                const product_variants_units:any = ProductUtil.parseProductUnit(item?.product_id, product_variants, product_units_lockup)
                let itemRoot = {
                    name: item?.product_id?.name,
                    sku: item?.product_id?.sku,
                    stock_max: item?.product_id?.stock_max,
                    stock_min: item?.product_id?.stock_min,
                    type: item?.product_id?.type,
                    status: item?.product_id?.status,
                    height: item?.product_id?.height,
                    weight: item?.product_id?.weight,
                    width: item?.product_id?.width,
                    longs: item?.product_id?.longs,
                    vat: item?.product_id?.vat,
                    price: item?.product_id?.price,
                    price_import: item?.product_id?.price_import,
                    price_wholesale: item?.product_id?.price_wholesale,
                    product_id: item?.product_id?.id,
                    variant_id: null,
                    value: `${item?.id}`,
                    label: item?.product_id?.name,
                    units: product_variants_units,
                    batchs: ProductUtil.parseProductBatch(item?.product_id?.product_batchs || [])
                }
                if(item?.variant_id){
                    const itemVariant = item?.variant_id
                    const product_variants_units:any = ProductUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                    itemRoot = {
                        ...itemRoot,
                        name: itemVariant?.name,
                        sku: itemVariant?.sku,
                        vat: itemVariant?.vat,
                        price: itemVariant?.price,
                        price_import: itemVariant?.price_import,
                        price_wholesale: itemVariant?.price_wholesale,
                        product_id: item?.id,
                        variant_id: itemVariant?.id,
                        value: `${item?.id}-${itemVariant?.id}`,
                        label: itemVariant?.name,
                        units: product_variants_units,
                        batchs: ProductUtil.parseProductBatch(itemVariant?.product_batchs || [])
                    }
                }
                prev = [...prev, {
                    // id: item?.id,
                    product_id: item?.product_id?.id,
                    variant_id: item?.variant_id?.id,
                    product: itemRoot,
                    quantity: item?.quantity,
                    quantity_request: item?.quantity,
                    price: itemRoot?.price_import,
                    price_request: item?.price_request,
                    discount: item?.discount,
                    unit_id: item?.unit_id?.id || 0,
                    batch_id: item?.batch_id?.id || 0,
                }]
                return prev
            },[]);
            const resDataProductThenMerge:any = await mergeProductByImport(resDataProduct)
            setProductByImport([...resDataProductThenMerge])
            if(autoFill) setProduct([...resDataProductThenMerge])
        }
    }

    const mergeProductByImport = async (data:any)=>{
        return new Promise(resolve => {
            let dataLock:any[] = [];
            let dataMerge:any[] = [];
            data?.map(async(item:any, index:number)=>{
                const indexOf = findIndex(dataMerge, (e:any) => {
                    return (
                        e?.batch_id && (e?.batch_id === item.batch_id)
                        && (
                            e?.batch_id === item.batch_id 
                            && e?.product_id === item.product_id 
                            && e?.variant_id === item.variant_id 
                        )
                    );
                }, 0);
                if(indexOf > -1){
                    const quantity = Number(dataMerge[indexOf].quantity || 0) + Number(item.quantity || 0)
                    dataMerge[indexOf].quantity = quantity
                }else{
                    dataMerge.push(item)
                }
                dataLock.push(item)
                if(data?.length === dataLock?.length){
                    resolve(dataMerge);
                }
            })
            return dataMerge
        });
    }

    const handleUpdateBatch = (dataBatch:any, product_id:number, variant_id:number, indexProduct:number)=>{
        const products = product?.filter((item:any)=>{
            return item?.product_id === product_id && item?.variant_id === variant_id
        })
        let curBatch = products && products[0] && products[0]?.product && products[0]?.product?.batchs || []
        let newBatch = [...curBatch, ...ProductUtil.parseProductBatch(dataBatch)]
        if(products && products[0] && products[0]?.product){
            //update lại số lô
            product?.map((item:any, index:number)=>{
                if(item?.product_id === product_id && item?.variant_id === variant_id){
                    product[index].product.batchs = newBatch
                }
            })
            //set lại lô cho sp đang sửa
            product[indexProduct].batch_id = dataBatch[0]?.id 
            product[indexProduct].quantity = dataBatch[0]?.quantity_import
            const newProductBatch = dataBatch?.reduce((prev:any, item:any, index:number)=>{
                if(0 !== index){
                    prev = [...prev,{
                        ...products[0],
                        batch_id: item?.id,
                        quantity: item?.quantity_import
                    }]
                }
                return prev
            },[])
            setProduct([...product, ...newProductBatch])
        }
        
    }

    const validationFrom = (showToastValidation?:boolean, dataValidation?:any) => {
        let newValidation:any = {}
        if (!data.supplier_id) {
            newValidation.supplier_id = 'Nhà cung cấp không được để trống!'
        }
        if (!data.branch_id) {
            newValidation.branch_id = 'Cơ sở (Kho) nhập không được để trống!'
        }
        if (!data.stock_import_ids) {
            newValidation.stock_import_ids = 'Mã phiếu nhập không được để trống!'
        }
        const productIdsLookUp:any = []
        const productBatIdsLookUp:any = []
        const productQuantityLookUp:any = {}
        if(productByImport){
            productByImport?.map((item:any, index:number)=>{
                //sản phẩm
                if(!productIdsLookUp[item?.product_id]) productIdsLookUp[item?.product_id] = {}
                if(!productIdsLookUp[item?.product_id][item?.variant_id || 0]) productIdsLookUp[item?.product_id][item?.variant_id || 0] = {}
                productIdsLookUp[item?.product_id][item?.variant_id || 0] = item
                //lô
                if(!productBatIdsLookUp[item?.product_id]) productBatIdsLookUp[item?.product_id] = {}
                if(!productBatIdsLookUp[item?.product_id][item?.variant_id || 0]) productBatIdsLookUp[item?.product_id][item?.variant_id || 0] = {}
                if(!productBatIdsLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0]) productBatIdsLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = {}
                productBatIdsLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = item?.batch_id
                //số lượng
                if(!productQuantityLookUp[item?.product_id]) productQuantityLookUp[item?.product_id] = {}
                if(!productQuantityLookUp[item?.product_id][item?.variant_id || 0]) productQuantityLookUp[item?.product_id][item?.variant_id || 0] = {}
                if(!productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0]) productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = {}
                if(!productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0]) productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = {}
                productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = Number(item?.quantity || 0)
            })
        }
        product?.map((item:any, index:number)=>{
            if(!newValidation.product) newValidation.product = {}
            if(!newValidation.product[index]) newValidation.product[index] = {}
            // Nếu không có triong danh sách thì báo lỗi
            const product_import = productIdsLookUp && productIdsLookUp[item?.product_id] && productIdsLookUp[item?.product_id][item?.variant_id || 0]
            const batch_id_import = productBatIdsLookUp && productBatIdsLookUp[item?.product_id] && productBatIdsLookUp[item?.product_id][item?.variant_id || 0] && productBatIdsLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0]
            const quantityImport = productQuantityLookUp && productQuantityLookUp[item?.product_id] && productQuantityLookUp[item?.product_id][item?.variant_id || 0] && productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0]
            if(!product_import){
                newValidation.product[index].product_id = 'Sản phẩm không thuộc phiếu nhập'
            }
            if(item?.product?.type === 'batch' && !batch_id_import){
                newValidation.product[index].batch_id = 'Lô không có trong phiếu nhập'
            }
            if(quantityImport < item?.quantity){
                newValidation.product[index].quantity = 'Số lượng trả không được lớn hơn số nhập'
            }
            if(
                !item?.product_id
                || !item?.quantity
                || (item?.product?.type === 'batch' && !item?.batch_id)
            ){
                if(!item?.product_id) newValidation.product[index].product_id = 'Sản phẩm không được để trống!'
                if(!item?.quantity) newValidation.product[index].quantity = 'Số lượng không được để trống!'
                if(item?.product?.type === 'batch' && !item?.batch_id) newValidation.product[index].batch_id = 'Lô không được để trống!'
            }
        })
        payment?.map((item:any, index:number)=>{
            const vnpay_payment = [payment_method.vnpay_qr_id, payment_method.vnpay_spos_id].includes(Number(item?.payment_method_id))
            if(
                (
                    (item?.payment_method_id && !item?.payment_total)
                    || (!item?.payment_method_id && item?.payment_total)
                )
                || (
                    vnpay_payment && (
                        !(item?.payment_method_id && item?.payment_total && item?.vnpay_terminal_id)
                    )
                )
            ){
                if(!newValidation.payment) newValidation.payment = {}
                if(!newValidation.payment[index]) newValidation.payment[index] = {}
                if(item?.payment_method_id && !item?.payment_total) newValidation.payment[index].payment_total = 'Giá trị không được để trống!'
                if(!item?.payment_method_id && item?.payment_total) newValidation.payment[index].payment_method_id = 'Hình thức không được để trống!'
                if(!item?.vnpay_terminal_id) newValidation.payment[index].vnpay_terminal_id = 'Máy POS không được để trống!'
            }
        })
        if(dataValidation){
            newValidation = dataValidation
        }
        setValidation({...newValidation})
        let newValidationAray:any = Object.values(newValidation)
        newValidationAray = newValidationAray?.reduce((prev:any, item:any)=>{
            let newItem:any = []
            if(typeof item === 'string'){
                newItem = [item]
            }else{
                newItem = Object.values(item)?.reduce((prevChild:any, itemChild:any)=>{
                    prevChild = [...prevChild, ...Object.values(itemChild)]
                    return prevChild
                },[])
            }
            prev = [
                ...prev, ...newItem
            ]
            return prev
        },[])
        newValidationAray = union(newValidationAray);
        if(newValidationAray?.length > 0){
            showToastValidation && toast.warning(newValidationAray.join(', '));
            return false
        }
        return true
    }
    
    const handleSubmit = async(type?:string) => {
        if (!validationFrom(true)) return;
        setLoading(true)
        const url = `${baseUrl}/stock/return`;
        const stock_return_products = product?.reduce((prev:any, item:any)=>{
            prev = [...prev,{
                "product_id": item?.product_id,
                "variant_id": item?.variant_id || undefined,
                "quantity": Number(item?.quantity || 0),
                "price": Number(item?.price || 0),
                "discount": Number(item?.discount || 0),
                "unit_id": item?.unit_id ? item?.unit_id : undefined,
                "batch_id": item?.batch_id ? item?.batch_id : undefined,
            }]
            return prev
        },[])
        const stock_return_payments = payment?.reduce((prev:any, item:any)=>{
            if(item?.payment_total){
                prev = [...prev, {
                    id: item?.id || undefined,
                    payment_method_id: item?.payment_method_id,
                    payment_total: Number(item?.payment_total),
                    vnpay_terminal_id: Number(item?.vnpay_terminal_id),
                }]
            }
            return prev
        },[])
        const params = {
            "supplier_id": data?.supplier_id,
            "branch_id": data?.branch_id,
            "code": data?.code,
            "stock_import_id": data?.stock_import_id,
            "stock_import_ids": data?.stock_import_ids?.reduce((prev:any, item:any)=>{
                prev = [...prev, item?.id]
                return prev
            },[]),
            "note": data?.note,
            "status": type === 'active' ? 1 : type === 'return' ? 2 : 0,
            "discount_value": Number(data?.discount_value || 0),
            "discount_type": data?.discount_type,
            "vat": Number(data?.vat || 0),
            "stock_return_products": stock_return_products,
            "stock_return_payments": stock_return_payments?.length > 0 ? stock_return_payments : undefined,
        }
        
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            if(response.response?.payment_sync?.length > 0){
                setPaymentSynce(response?.response?.payment_sync)
                handleActionModal({
                  type: "paymentProcess",
                  data: response.response,
                  onSubmit: () => {
                    // type === 'active' ? 1 : type === 'import' ? 2 : 0,
                    if( params?.status === 1) toast.success('Xác nhận phiếu trả hàng thành công')
                    if( params?.status === 2) toast.success('Nhập kho phiếu trả hàng thành công')
                    if( params?.status === 0) toast.success('Tạo mới phiếu trả hàng thành công')
                    router?.push(`/stockreturn/${response.response?.id}/view`)
                  },
                  onClose: () => {
                    // type === 'active' ? 1 : type === 'import' ? 2 : 0,
                    if( params?.status === 1) toast.success('Xác nhận phiếu trả hàng thành công')
                    if( params?.status === 2) toast.success('Nhập kho phiếu trả hàng thành công')
                    if( params?.status === 0) toast.success('Tạo mới phiếu trả hàng thành công')
                    router?.push(`/stockreturn/${response.response?.id}/view`)
                  },
                });
            }else{
                // type === 'active' ? 1 : type === 'import' ? 2 : 0,
                if( params?.status === 1) toast.success('Xác nhận phiếu trả hàng thành công')
                if( params?.status === 2) toast.success('Nhập kho phiếu trả hàng thành công')
                if( params?.status === 0) toast.success('Tạo mới phiếu trả hàng thành công')
                router?.push(`/stockreturn/${response.response?.id}/view`)
            }
            
        }
    }

    const handleEdit = async() => {
        if (!validationFrom(true)) return;
        setLoading(true)
        const url = `${baseUrl}/stock/return/${id}`;
        const stock_return_products = product?.reduce((prev:any, item:any)=>{
            prev = [...prev,{
                "product_id": item?.product_id,
                "variant_id": item?.variant_id || undefined,
                "quantity": Number(item?.quantity || 0),
                "price": Number(item?.price || 0),
                "discount": Number(item?.discount || 0),
                "unit_id": item?.unit_id ? item?.unit_id : undefined,
                "batch_id": item?.batch_id ? item?.batch_id : undefined,
            }]
            return prev
        },[])
        const stock_return_payments = payment?.reduce((prev:any, item:any)=>{
            if(item?.payment_total){
                prev = [...prev, {
                    id: item?.id || undefined,
                    payment_method_id: item?.payment_method_id,
                    payment_total: Number(item?.payment_total),
                    vnpay_terminal_id: Number(item?.vnpay_terminal_id),
                }]
            }
            return prev
        },[])
        const params = {
            "supplier_id": data?.supplier_id,
            "branch_id": data?.branch_id,
            "code": data?.code,
            "stock_import_id": data?.stock_import_id,
            "note": data?.note,
            "status": 0,
            "discount_value": Number(data?.discount_value || 0),
            "discount_type": data?.discount_type,
            "vat": Number(data?.vat || 0),
            "stock_return_products": stock_return_products,
            "stock_return_payments": stock_return_payments?.length > 0 ? stock_return_payments : undefined,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            if(response.response?.payment_sync?.length > 0){
                setPaymentSynce(response?.response?.payment_sync)
                handleActionModal({
                  type: "paymentProcess",
                  data: response.response,
                  onSubmit: () => {
                    toast.success('Chỉnh sửa phiếu trả hàng thành công')
                    router?.push(`/stockreturn/${response.response?.id}/view`)
                  },
                  onClose: () => {
                    toast.success('Chỉnh sửa phiếu trả hàng thành công')
                    router?.push(`/stockreturn/${response.response?.id}/view`)
                  },
                });
            }else{
                toast.success('Chỉnh sửa phiếu trả hàng thành công')
                router?.push(`/stockreturn/${response.response?.id}/view`)
            }
            
        }
    }

    return (
        <div style={{paddingBottom:50}}>
            <React.Fragment>
                {
                    !from &&
                    <PageTitle
                        breadCrumbItems={[
                            { label: `${type == 'view' ? 'Xem chi tiết' : id !== 'add' ? 'Chỉnh sửa' : 'Thêm mới'} phiếu trả hàng`, active: true },
                        ]}
                        title={`${type == 'view' ? 'Xem chi tiết' : id !== 'add' ? 'Chỉnh sửa' : 'Thêm mới'} phiếu trả hàng`}
                    />
                }
                <ContentPage 
                    history={history}
                    data={data}
                    productByImport={productByImport}
                    supplier={supplier}
                    setData={(val:any) => setData(val)}
                    supplierInfo={supplierInfo}
                    setSupplierInfo={(val:any) => setSupplierInfo(val)}
                    branch={branch}
                    product={product}
                    productTemplate={productTemplate}
                    stockImportTemplate={stockImportTemplate}
                    setProduct={(val:any) => setProduct(val)}
                    onlyView={onlyView}
                    id={id}
                    type={type}
                    action={action}
                    handleActionModal={(data:any) => handleActionModal(data)}
                    from={from}
                    closeModal={closeModal}
                    fetchCustomerExam={fetchCustomerExam}
                    payment={payment}
                    paymentMethod={paymentMethod}
                    vnpayTerminal={vnpayTerminal}
                    setPayment={setPayment}
                    validation={validation}
                    setValidation={setValidation}
                    validationFrom={validationFrom}
                    handleSubmit={handleSubmit}
                    handleEdit={handleEdit}
                />
                <ModalPopup
                    isOpen={modalIsOpen}
                    onRequestClose={() => {
                        if(action?.onClose){
                            action.onClose()
                        }
                        setIsOpen(false)}
                    }
                >
                {action?.type === 'addBatch' ? 
                    <BatchAdd closeModal={() => setIsOpen(false)} action={action} onUpdateBatch={handleUpdateBatch} 
                    product_name={action?.data?.product?.name} 
                    product_id={action?.data?.product_id} 
                    variant_id={action?.data?.variant_id} 
                    sku={action?.data?.product?.sku} 
                    indexProduct={action?.indexProduct} 
                    />
                :action?.type === 'addPayment' ? 
                    <PaymentAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} import_id={action?.import_id} />
                :action?.type === 'paymentProcess' ? 
                <RenderActionOrderModal
                    {...props}
                    closeModal={() => setIsOpen(false)}
                    action={action}
                    paymentSynce={paymentSynce}
                />
                :<RenderActionModal closeModal={() => setIsOpen(false)} action={action} loadData={() => {
                    loadData(id)
                    loadHistory(id)
                }} />
                }
                    
                </ModalPopup>
                {loading && <Loader />}
            </React.Fragment>
        </div>
    );
};

const ContentPage = (props:any) => {
    const {vnpayTerminal, validationFrom, handleSubmit, handleEdit, setValidation, validation, productByImport, history, paymentMethod, supplierInfo, setSupplierInfo, data, type, setData, branch, onlyView, id, setProduct, product, productTemplate, stockImportTemplate, supplier, payment, setPayment, action, handleActionModal, 
    from} = props
    const [loading, setLoading] = useState(false)
    const router = useHistory()
    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone" || name === "guardian_phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        if(value?.length > 1000) return;
        setData({
            ...data,
            [name]: value
        })
    }

    const handleProductAdd = () => {
        const newDetailtiveUser = {
            product_id: "",
            variant_id: "",
            product: {},
            quantity:"",
        };
        setProduct([...product, newDetailtiveUser]);
    };

    const handleProductUpdate = (dataDetail: any, index: number) => {
        // check xem đã có sp kia trong danh sách chưa nha
        const checkIsset = product?.reduce((prev:any, item:any, indexCheck:number)=>{
            if(indexCheck !== index && item?.product_id === dataDetail?.product_id && item?.variant_id === dataDetail?.variant_id){
                if(dataDetail?.product?.type !== 'batch'){
                    prev = false
                }else if(dataDetail?.product?.type === 'batch' && item?.batch_id === dataDetail?.batch_id){
                    prev = false
                } 
            }
            return prev
        }, true)
        if(!checkIsset){
            toast.warning('Sản phẩm đã được thêm')
            return
        }
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser[index] = dataDetail;
        setProduct(newDetailtiveUser);
    };

    const handleProductRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser.push({
            product_id: "",
            variant_id: "",
            product_info: {},
            quantity:"",
        })
        setProduct(newDetailtiveUser);
    };

    const handlePaymentAdd = () => {
        const newDetailtiveUser = {
            payment_id: "",
            quantity:"",
        };
        setPayment([...payment, newDetailtiveUser]);
    };

    const handlePaymentUpdate = (dataDetail: any, index: number) => {
        let newDetailtiveUser = cloneDeep(payment);
        newDetailtiveUser[index] = dataDetail;
        setPayment(newDetailtiveUser);
    };

    const handlePaymentRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(payment);
        newDetailtiveUser.splice(index, 1);
        setPayment(newDetailtiveUser);
    };

    const calTotal = ()=>{
        const totalPayment = product?.reduce((prev:any, item:any)=>{
            if(item?.price && item?.quantity) prev = prev + (Number(item?.price ||  0) * Number(item?.quantity || 0) - Number(item?.discount || 0))
            return prev
        },0)
        return Math.floor(totalPayment || 0)
    }

    const calTotalEnd = ()=>{
        const totalPayment = calTotal()
        const discount = Number(
            data?.discount_type === 'percent' ? Number(data?.discount_value || 0) * totalPayment / 100
            : Number(data?.discount_value || 0)
        )
        const vat = (totalPayment - discount) * Number(data?.vat || 0) / 100
        return Math.floor(totalPayment + vat - discount)
    }

    const calTotalPayment = ()=>{
        const totalPayment = payment?.reduce((prev:any, item:any)=>{
            if(item?.payment_total) prev = prev + Number(item?.payment_total)
            return prev
        },0)
        return Math.floor(totalPayment || 0)
    }

    const getLabelStatus = (status:any) => {
        switch(status) {
            case -1: {
                return <span className="ml-2 label-status bg-danger">Hủy phiếu</span>
                break;
            }
            case 0: {
                return <span className="ml-2 label-status bg-dark">Mới</span>
                break;
            }
            case 1: {
                return <span className="ml-2 label-status bg-success">Duyệt trả</span>
                break;
            }
            case 2: {
                return <span className="ml-2 label-status bg-info">Đã xuất trả</span>
                break;
            }
            default: {
                return null
                break;
            }
        }
    }

    const [loadingStockImport, setLoadingStockRequest] = useState(false);
    const [queryStockImport, setQueryStockRequest] = useState('')

    const handleInputChangeStockImport = (newValue:any) => {
        setQueryStockRequest( newValue);
        return newValue;
    };

    const loadStockImport = async () => {
        setLoadingStockRequest(true)
        let response: any = await APIClient.GET(`${baseUrl}/stock/import`,{
            page: 1,
            limit: 100,
            status: 2,
            supplier_id: data?.supplier_id,
            name: queryStockImport
        });
        setLoadingStockRequest(false)
        if (response.response?.data !== undefined) {
            const ListArr = response.response?.data?.reduce((prev:any, item:any)=>{
                prev = [...prev,
                    {
                        label:item?.code,
                        value:item?.id
                    }
                ]
                return prev
            },[])
            return ListArr
        }else{
            return []
        }
    };

    return (
        <PageContent style={from=='exam' ? {width:'900px', maxHeight:'80vh', overflowX:'hidden'}: {}} className={onlyView ? 'only-view' : ''}>
            <Row>
                <Col md={9} xs={12}>
                    <PageBody>
                        <div className="nutri-title mb-3">Thông tin phiếu trả hàng {getLabelStatus(data?.status)}</div>
                        <Row>
                            
                            <Col md={3} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Nhà cung cấp</Label>
                                    <Select
                                        placeholder="Chọn nhà cung cấp"
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        isDisabled={onlyView}
                                        onChange={(val: any) => {
                                            setData({ ...data, supplier_id: val?.value })
                                            setSupplierInfo(val)
                                        }}
                                        value={supplier?.filter(
                                            (option: any) => data?.supplier_id == option.value
                                        )}
                                        options={supplier}
                                        components={{ Menu: (props:any)=>(
                                            <components.Menu {...props} >
                                                {props.children}
                                                <Link to="/supplier/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                                    <i className="uil-plus mr-1"></i> Tạo mới nhà cung cấp
                                                </Link>
                                            </components.Menu>
                                        )}}
                                        styles={{
                                            ...customStyles,
                                            menu: ({ width, ...css }) => ({
                                                ...css,
                                                minWidth: 300,
                                            }),
                                        }}
                                    ></Select>
                                </FormGroup>
                            </Col>
                            <Col md={3} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Mã phiếu</Label>
                                    {type === 'view' ?
                                        <ValueText className='only-view'>{data?.code}</ValueText>
                                        :<Input type="text" value={data?.code} onChange={(e: any) => handleChangeInput(e)} name="code" placeholder={(type=='view' && !data?.code) ? "---" : "Nhập mã phiếu"} />
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={6} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span> Mã phiếu nhập</Label>
                                    {type === 'view' ?
                                        <ValueText className='only-view'>{data?.stock_import_ids?.map((u:any) => u.label).join(', ')}</ValueText>
                                        :<AsyncSelect
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            onInputChange={handleInputChangeStockImport}
                                            loadOptions={loadStockImport}
                                            inputValue={queryStockImport}
                                            placeholder={loadingStockImport ? "Đang tải dữ liệu..." : "Nhập tên, mã..."}
                                            noOptionsMessage={() => queryStockImport ? "Không tìm thấy dữ liệu" : 'Nhập mã phiếu yêu cầu nhập'}
                                            loadingMessage={() => 'searching...'}
                                            styles={customStyles}
                                            cacheOptions
                                            defaultOptions={stockImportTemplate}
                                            onChange={(val: any) => {
                                                handleChangeInput({target:{value: val, name: 'stock_import_ids'}})
                                            }}
                                            value={data?.stock_import_ids}
                                            isMulti
                                            isDisabled={onlyView || !data?.supplier_id}
                                        />
                                    }
                                </FormGroup>
                            </Col>
                            
                            
                            <Col md={9} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Ghi chú</Label>
                                    <Input type="text" value={data?.note} onChange={(e: any) => handleChangeInput(e)} name="note" placeholder={(type=='view' && !data?.note) ? "---" : "Nhập ghi chú"} />
                                </FormGroup>
                            </Col>
                            <Col md={3} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Cơ sở (Kho) nhập</Label>
                                    <Select
                                        placeholder="Chọn cơ sở"
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        isDisabled={onlyView}
                                        onChange={(val: any) => {
                                            setData({ ...data, branch_id: val?.value })
                                        }}
                                        value={branch?.filter(
                                            (option: any) => data?.branch_id == option.value
                                        )}
                                        options={branch}
                                        components={{ Menu: (props:any)=>(
                                            <components.Menu {...props} >
                                                {props.children}
                                                <Link to="/setting/medicalbasis/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                                    <i className="uil-plus mr-1"></i> Tạo mới cơ sở
                                                </Link>
                                            </components.Menu>
                                        )}}
                                        styles={{
                                            ...customStyles,
                                            menu: ({ width, ...css }) => ({
                                                ...css,
                                                minWidth: 400,
                                            }),
                                        }}
                                    ></Select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mb-3" style={{display: 'flex', justifyContent:'space-between'}}>
                            <div className="nutri-title">Sản phẩm</div>
                            {type !== 'view' &&
                            <div className='select-menu-add' style={{
                                margin: 0,
                                border: 'none',
                                padding: 0
                            }} onClick={()=>{
                                setProduct(productByImport)
                                setValidation({...{}})
                            }}>
                                <i className="uil-plus mr-1"></i> Thêm nhanh tất cả sản phẩm trong phiếu nhập
                            </div>}
                        </div>
                        <div className="table-responsive" style={{overflow: 'unset'}}>
                            <table className="mb-0 table-custom no-bg table table-input" >
                                <thead>
                                    <tr>
                                        <th style={{ width: '20%' }}><span className='require'>*</span> Tên sản phẩm</th>
                                        <th style={{ width: '8%' }}><span className='require'>*</span> Mã SKU</th>
                                        <th style={{ width: '8%' }}>Mã Lô</th>
                                        <th style={{ width: '8%' }}><span className='require'>*</span> Đơn vị</th>
                                        <th style={{ width: '10%' }}><span className='require'>*</span> SL trả</th>
                                        <th style={{ width: '10%' }}><span className='require'>*</span> Giá nhập</th>
                                        <th style={{ width: '10%' }}>Giảm giá</th>
                                        <th style={{ width: '10%' }}><span className='require'>*</span> Thành tiền</th>
                                        {!onlyView &&<th style={{ width: '6%' }}></th>}
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    product?.map((item:any, index:number) => (
                                        <ProductItem 
                                            key={`ProductItem-${item?.product_id}-${index}`}
                                            handleActionModal={handleActionModal}
                                            detailIndex={index} 
                                            data={item}
                                            dataParent={data}
                                            onChangeData={(dataDetail: any) =>
                                                handleProductUpdate(dataDetail, index)
                                            }
                                            productTemplate={productTemplate}
                                            type={type}
                                            onlyView={onlyView}
                                            handleRemoveData={() => {
                                                handleProductRemove(index)
                                                validationFrom(false)
                                            }}
                                            handleAddData={() => {
                                                handleProductAdd()
                                                validationFrom(false)
                                            }}
                                            detail={product}
                                            validationFull={validation}
                                            validation={validation && validation.product && validation.product[index]}
                                            onValidation={(dataValidation:any)=>{
                                                validationFrom(false, dataValidation)
                                            }}
                                            productByImport={productByImport}
                                        />
                                    ))
                                }
                                </tbody>
                            </table>
                            <Col md={5} style={{float: 'right'}}>
                                <div style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Tổng tiền </ValueTextLabel>
                                    <ValueTextValue className='only-view' style={{flexDirection: 'row-reverse'}}>{PriceUtils.format(calTotal())}</ValueTextValue>
                                </div>
                                <div className='mb-2' style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Giảm giá </ValueTextLabel>
                                    <ValueTextValue>
                                        <div className='stock-import-discount-group'>
                                            <NumberFormat 
                                                disabled={type === 'view'}
                                                onChange={(e: any) => handleChangeInput({ target: { name: 'discount_value', value: TextUtils.onlyNumber(e.target.value) } })}
                                                name={'discount_value'} type={'text'} className="form-control discount_value" 
                                                value={type === 'view' && !data?.discount_value ? '---': data?.discount_value}
                                                placeholder={(type=='view' && !data?.discount_value) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                                            />
                                            <Select
                                                placeholder={(type=='view' && !data?.discount_type) ? "---" : "Chọn"}
                                                className="react-select discount_type"
                                                classNamePrefix="react-select"
                                                isDisabled={onlyView}
                                                onChange={(val: any) => handleChangeInput({ target: { name: 'discount_type', value: val?.value } })}
                                                value={DiscountType?.filter(
                                                    (option: any) => data?.discount_type == option.value
                                                )}
                                                options={DiscountType}
                                            ></Select>
                                        </div>
                                    </ValueTextValue>
                                </div>
                                <div style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>VAT </ValueTextLabel>
                                    <ValueTextValue>
                                        <div className='stock-import-discount-group'>
                                            <NumberFormat 
                                                disabled={type === 'view'}
                                                onChange={(e: any) => handleChangeInput({ target: { name: 'vat', value: TextUtils.onlyNumber(e.target.value) } })}
                                                name={'vat'} type={'text'} className="form-control discount_type" 
                                                value={type === 'view' && !data?.vat ? '---': data?.vat}
                                                placeholder={(type=='view' && !data?.vat) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                                            />
                                        </div>
                                    </ValueTextValue>
                                </div>
                                <div style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Tổng tiền thanh toán: </ValueTextLabel>
                                    <ValueTextValue className='only-view' style={{flexDirection: 'row-reverse'}}>{PriceUtils.format(calTotalEnd())}</ValueTextValue>
                                </div>
                            </Col>
                            
                        </div>
                        
                    </PageBody>
                </Col>
                <Col md={3} xs={12}>
                    <div className="card">
                        <div className="card-body p-0">
                            <div style={{padding:' 1.25rem'}}>
                                <div className="mb-3" style={{display: 'flex', justifyContent:'space-between'}}>
                                    <div className="nutri-title">Thông tin thanh toán</div>
                                    {/* <div style={{display: 'flex', justifyContent:'space-between'}}>
                                        <ValueTextLabel>Tổng tiền: </ValueTextLabel>
                                        <ValueTextTotal className='only-view'>{PriceUtils.format(calTotalPayment())}</ValueTextTotal>
                                    </div> */}
                                    
                                </div>
                                {
                                    type != 'view' && payment?.length === 0 ?
                                    <div style={{display: 'flex', justifyContent: 'center'}}>
                                        <Button onClick={handlePaymentAdd} color='success'><i className='uil-plus'></i> Thêm phương thức thanh toán</Button>
                                    </div>
                                    :payment?.map((item:any, index:number) => (
                                        <PaymentItem 
                                            key={`PaymentItem-${index}`}
                                            detailIndex={index} 
                                            data={item}
                                            onChangeData={(dataDetail: any) =>
                                                handlePaymentUpdate(dataDetail, index)
                                            }
                                            paymentMethod={paymentMethod}
                                            vnpayTerminal={vnpayTerminal}
                                            type={type}
                                            onlyView={onlyView}
                                            handleRemoveData={() => handlePaymentRemove(index)}
                                            handleAddData={() => handlePaymentAdd()}
                                            detail={payment}
                                        />
                                    ))
                                }
                            </div>
                            <div style={{
                                display: 'flex', 
                                justifyContent:'flex-end', 
                                background: '#ECECF2', 
                                padding:'8px 1.25rem', 
                                overflow: 'hidden', 
                                borderBottomRightRadius: '0.5rem',
                                borderBottomLeftRadius: '0.5rem',
                                flexDirection: 'column'
                            }}>
                                <div style={{display: 'flex', flex: 1, justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Còn lại cần thanh toán</ValueTextLabel>
                                    <ValueTextLabel className='only-view' style={{flexDirection:'row-reverse'}}>{PriceUtils.format(calTotalEnd() - calTotalPayment())}</ValueTextLabel>
                                </div>
                                <div style={{display: 'flex',flex: 1, justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Tổng công nợ hiện tại: </ValueTextLabel>
                                    <ValueTextLabel className='only-view' style={{flexDirection:'row-reverse'}}>{PriceUtils.format(supplierInfo?.total_debt || 0)}</ValueTextLabel>
                                </div>
                            </div>
                        </div>
                    </div>
                    {type === 'view' && <History history={history}/>}
                </Col>
            </Row>
           
            {
                // !from &&
                <div className="bottom-action">
                    <Button color="success" className='dark-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                    {
                        id === 'add' && 
                        <>
                            
                            <Button color="primary" className='ml-2' onClick={() => props?.handleActionModal({type: 'returnConfirm', data: data, onSubmit:()=>handleSubmit('return') })}>Xuất trả</Button>
                            <Button color="success" className='success-bland ml-2' onClick={() => props?.handleActionModal({type: 'activeConfirm', data: data, onSubmit:()=>handleSubmit('active')})}>Đã duyệt</Button>
                            <Button color="success" className='ml-2' onClick={()=>handleSubmit()}>Lưu</Button>
                        </>
                    }
                    {
                        id && type == 'view' && data?.status == 0 && 
                        <>
                            {/* <Button color="danger" className='danger ml-2' onClick={() => props?.handleActionModal({type: 'delete', data: data})}>Xóa</Button> */}
                            <Button color="success" className='danger-bland ml-2' onClick={() => props?.handleActionModal({type: 'reject', data: data})}>Hủy phiếu</Button>
                            <Button color="success" className='success-bland ml-2' onClick={() => props?.handleActionModal({type: 'active', data: data})}>Đã duyệt</Button>
                            <Button color="primary" className='ml-2' onClick={() => props?.handleActionModal({type: 'return', data: data})}>Xuất trả</Button>
                            <Button color="success" className='ml-2' onClick={() => router?.push(`/stockreturn/${id}`)}>Chỉnh sửa</Button>
                        </>
                    }
                    {
                        id && type == 'view' && data?.status == 1 && 
                        <>
                            <Button color="primary" className='ml-2' onClick={() => props?.handleActionModal({type: 'return', data: data})}>Xuất trả</Button>
                            <Button color="danger" className='ml-2' onClick={() => props?.handleActionModal({type: 'reject', data: data})}>Hủy phiếu</Button>
                        </>
                    }
                     {
                        id && type == 'view' && data?.status == 2 && data?.payment_status !== 'paid' &&
                        <>
                            {/* <Button color="success" className='ml-2' onClick={() => props?.handleActionModal({type: 'addPayment', import_id: id})}>Thanh toán</Button> */}
                            
                        </>
                    }
                    {
                        id !== 'add' && type != 'view' &&
                        <Button color="success" className='ml-2' onClick={handleEdit}>Lưu</Button>
                    }
                </div>
            }
            
            {loading && <Loader />}
        </PageContent>
    )
}

const ProductItem = (props:any) => {
    const {productByImport, onValidation, validation, validationFull, detailIndex, detail, onChangeData, data, dataParent, productTemplate, type, onlyView, handleRemoveData, handleAddData, handleActionModal} = props
    const [loadingDesignation, setLoadingProduct] = useState(false);
    const [queryDesignation, setQueryDesignation] = useState('')

    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        const newItem = {
            ...data,
            [name]: value
        }
        onChangeData(newItem)
        handleValidation(newItem)
    }

    const handleValidation = (newItem:any)=>{
        const newValidation:any = validationFull
        if(!newValidation?.product) newValidation.product = {}
        if(!newValidation?.product[detailIndex]) newValidation.product[detailIndex] = {}
        newValidation.product[detailIndex] = {}
        // Nếu không có triong danh sách thì báo lỗi
        const productIdsLookUp:any = []
        const productBatIdsLookUp:any = []
        const productQuantityLookUp:any = {}
        if(productByImport){
            productByImport?.map((item:any, index:number)=>{
                //sản phẩm
                if(!productIdsLookUp[item?.product_id]) productIdsLookUp[item?.product_id] = {}
                if(!productIdsLookUp[item?.product_id][item?.variant_id || 0]) productIdsLookUp[item?.product_id][item?.variant_id || 0] = {}
                productIdsLookUp[item?.product_id][item?.variant_id || 0] = item
                //lô
                if(!productBatIdsLookUp[item?.product_id]) productBatIdsLookUp[item?.product_id] = {}
                if(!productBatIdsLookUp[item?.product_id][item?.variant_id || 0]) productBatIdsLookUp[item?.product_id][item?.variant_id || 0] = {}
                if(!productBatIdsLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0]) productBatIdsLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = {}
                productBatIdsLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = item?.batch_id
                //số lượng
                if(!productQuantityLookUp[item?.product_id]) productQuantityLookUp[item?.product_id] = {}
                if(!productQuantityLookUp[item?.product_id][item?.variant_id || 0]) productQuantityLookUp[item?.product_id][item?.variant_id || 0] = {}
                if(!productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0]) productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = {}
                if(!productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0]) productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = {}
                productQuantityLookUp[item?.product_id][item?.variant_id || 0][item?.batch_id || 0] = Number(item?.quantity || 0)
            })
        }
        const product_import = productIdsLookUp && productIdsLookUp[newItem?.product_id] && productIdsLookUp[data?.product_id][newItem?.variant_id || 0]
        const batch_id_import = productBatIdsLookUp && productBatIdsLookUp[newItem?.product_id] && productBatIdsLookUp[newItem?.product_id][newItem?.variant_id || 0] && productBatIdsLookUp[newItem?.product_id][newItem?.variant_id || 0][newItem?.batch_id || 0]
        const quantityImport = productQuantityLookUp && productQuantityLookUp[newItem?.product_id] && productQuantityLookUp[newItem?.product_id][newItem?.variant_id || 0] && productQuantityLookUp[newItem?.product_id][newItem?.variant_id || 0][newItem?.batch_id || 0]
        if(!product_import){
            newValidation.product[detailIndex].product_id = 'Sản phẩm không thuộc phiếu nhập'
        }
        if(newItem?.product?.type === 'batch' && !batch_id_import){
            newValidation.product[detailIndex].batch_id = 'Lô không có trong phiếu nhập'
        }
        if(quantityImport < newItem?.quantity){
            newValidation.product[detailIndex].quantity = 'Số lượng trả không được lớn hơn số nhập'
        }
        if(
            !newItem?.product_id
            || !newItem?.quantity
            || (newItem?.product?.type === 'batch' && !newItem?.batch_id)
        ){
            if(!newItem?.product_id) newValidation.product[detailIndex].product_id = 'Sản phẩm không được để trống!'
            if(!newItem?.quantity) newValidation.product[detailIndex].quantity = 'Số lượng không được để trống!'
            if(newItem?.product?.type === 'batch' && !newItem?.batch_id) newValidation.product[detailIndex].batch_id = 'Lô không được để trống!'
        }
        onValidation(newValidation)
    }

    const loadProduct = async () => {
        setLoadingProduct(true)
        let response: any = await APIClient.GET(`${baseUrl}/product`,{
            page: 1,
            limit: 100,
            name: queryDesignation
        });
        setLoadingProduct(false)
        if (response.response?.data !== undefined) {
            const ListArr = ProductUtil.parseProduct(response.response?.data)
            return ListArr
        }else{
            return []
        }
    };

    const handleInputChangeProduct = (newValue:any) => {
        setQueryDesignation( newValue);
        return newValue;
    };

    const calTotalItem = ()=>{
        return Math.floor(
            Number(data?.price  || 0) * Number(data?.quantity  || 0) - Number(data?.discount  || 0)
        )
    }

    return (
        <tr key={`item-product-${detailIndex}`}>
            <td onClick={()=>{
                if(!dataParent?.supplier_id){
                    toast.warning("Bạn cần chọn trước Nhà cung cấp")
                }
            }}>
                <AsyncSelect
                    className="react-select"
                    classNamePrefix="react-select"
                    onInputChange={handleInputChangeProduct}
                    loadOptions={loadProduct}
                    inputValue={queryDesignation}
                    placeholder={loadingDesignation ? "Đang tải dữ liệu..." : "Nhập tên, mã..."}
                    noOptionsMessage={() => queryDesignation ? "Không tìm thấy dữ liệu" : 'Nhập tên, mã sản phẩm'}
                    loadingMessage={() => 'searching...'}
                    cacheOptions 
                    defaultOptions={productTemplate}
                    onChange={(val: any) => {
                        const newItem = {
                            ...data,
                            product_id: val?.product_id,
                            variant_id: val?.variant_id || undefined,
                            product: val,
                            batch_id: '',
                            unit_id: 0,
                            quantity: 1,
                            quantity_request: '',
                            price: val?.price_import,
                            discount: '',
                        }
                        onChangeData(newItem)
                        handleValidation(newItem)
                    }}
                    // value={productTemplate?.filter(
                    //     (option: any) => data?.product_id == option.product_id && data?.variant_id == option.variant_id
                    // )}
                    value={{
                        label: data?.product?.name
                    }}
                    isDisabled={onlyView || !dataParent?.supplier_id}
                    components={{ Menu: (props:any)=>(
                        <components.Menu {...props} >
                            {props.children}
                            <Link to="/product/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                <i className="uil-plus mr-1"></i> Tạo mới sản phẩm
                            </Link>
                        </components.Menu>
                    )}}
                    styles={{
                        ...customStyles,
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 500,
                        }),
                    }}
                />
                {validation?.product_id &&<div className="invalid-feedback d-block" >{validation?.product_id}</div>}
            </td>
            <td>
                <Input type="text" value={data?.product?.sku || ''} disabled={true} placeholder={(type=='view' && !data?.product?.sku) ? "---" : "Mã SKU"} />
            </td>
            
            {data?.product?.type === 'batch' ?
            <td style={{ width: '13%' }}>
                <Select
                    placeholder={(type=='view' && !data?.batch_id) ? "---" : "Chọn lô..."}
                    className="react-select"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                        const newItem = {
                            ...data,
                            batch_id: val?.value,
                        }
                        onChangeData(newItem)
                        handleValidation(newItem)
                    }}
                    value={data?.product?.batchs?.filter(
                        (option: any) => data?.batch_id === option.value
                    )}
                    options={data?.product?.batchs}
                    noOptionsMessage={() => 'Chưa có lô'}
                    components={{ Menu: (props:any)=>(
                        <components.Menu {...props} >
                            {props.children}
                            <div className='select-menu-add' onClick={()=>{
                                handleActionModal({type: 'addBatch', data: data, indexProduct: detailIndex})
                            }}>
                                <i className="uil-plus mr-1"></i> Tạo lô
                            </div>
                        </components.Menu>
                    )}}
                    styles={{
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 200,
                        }),
                    }}
                ></Select>
                {validation?.batch_id &&<div className="invalid-feedback d-block" >{validation?.batch_id}</div>}
            </td>:<td></td>
            }
            
            <td>
                <Select
                    placeholder={(type=='view' && !data?.unit_id) ? "---" : "Chọn đơn vị..."}
                    className="react-select"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                        const newItem = {
                            ...data,
                            unit_id: val?.value,
                        }
                        onChangeData(newItem)
                        handleValidation(newItem)
                    }}
                    value={data?.product?.units?.filter(
                        (option: any) => data?.unit_id === option.value
                    )}
                    options={data?.product?.units}
                    noOptionsMessage={() => 'Chưa có đơn vị'}
                    styles={{
                        ...customStyles,
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 200,
                        }),
                    }}
                ></Select>
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => handleChangeData({ target: { name: 'quantity', value: TextUtils.onlyNumber(e.target.value) } })}
                    name={'quantity'} type={'text'} className="form-control" 
                    value={type === 'view' && !data?.quantity ? '---': data?.quantity}
                    disabled={onlyView}
                    placeholder={(type=='view' && !data?.quantity) ? "---" : "Nhập số lượng..."} thousandSeparator={true} 
                />
                {validation?.quantity &&<div className="invalid-feedback d-block" >{validation?.quantity}</div>}
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => handleChangeData({ target: { name: 'price', value: TextUtils.onlyNumber(e.target.value) } })}
                    name={'price'} type={'text'} className="form-control" 
                    value={type === 'view' && !data?.price ? '---': data?.price}
                    disabled={onlyView}
                    placeholder={(type=='view' && !data?.price) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => handleChangeData({ target: { name: 'discount', value: TextUtils.onlyNumber(e.target.value) } })}
                    name={'discount'} type={'text'} className="form-control" 
                    value={type === 'view' && !data?.discount ? '---': data?.discount}
                    disabled={onlyView}
                    placeholder={(type=='view' && !data?.discount) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <NumberFormat 
                    name={'total'} type={'text'} className="form-control" 
                    value={calTotalItem()}
                    disabled={true}
                    placeholder={(type=='view' && !data?.total) ? "---" : "---"} thousandSeparator={true} 
                />
            </td>
            {(!onlyView && dataParent?.supplier_id) &&
            <td>
                <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                {
                    detail?.length == detailIndex+1 &&
                    <Button onClick={handleAddData} className='nutri-square mt-2' color='success'><i className='uil-plus'></i></Button>
                    // <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                }
            </td>}
        </tr>
    )
}

const PaymentItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, type, onlyView, handleRemoveData, handleAddData, paymentMethod, vnpayTerminal} = props
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if(name == 'name') {
            if(value?.length > 200) return
        }
        onChangeData({
            ...data,
            [name]: value
        })
    }

    const vnpay_payment = [payment_method.vnpay_qr_id, payment_method.vnpay_spos_id].includes(Number(data?.payment_method_id))
    
    return (
        <div className='payment-item' key={detailIndex}>
            <div className='payment-item-method'>
                <FormGroup className='nutri-form'>
                    <Label>Hình thức</Label>
                    <Select
                        placeholder={(type=='view' && !data?.payment_method_id) ? "---" : "Chọn"}
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView || data?.id}
                        onChange={(val: any) => handleChangeData({ target: { name: 'payment_method_id', value: val?.value } })}
                        value={paymentMethod?.filter(
                            (option: any) => data?.payment_method_id == option.value
                        )}
                        options={paymentMethod}
                    ></Select>
                </FormGroup>
            </div>
            {vnpay_payment &&
            <div className='payment-item-method'>
                <FormGroup className='nutri-form'>
                    <Label>Máy POS</Label>
                    <Select
                        placeholder={(type=='view' && !data?.vnpay_terminal_id) ? "---" : "Chọn"}
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView || data?.id}
                        onChange={(val: any) => handleChangeData({ target: { name: 'vnpay_terminal_id', value: val?.value } })}
                        value={vnpayTerminal?.filter(
                            (option: any) => data?.vnpay_terminal_id == option.value
                        )}
                        options={vnpayTerminal}
                    ></Select>
                </FormGroup>
            </div>}
            <div className='payment-item-price'>
                <FormGroup className='nutri-form'>
                    <Label>Số tiền</Label>
                    <NumberFormat 
                        disabled={data?.id}
                        onChange={(e: any) => handleChangeData({ target: { name: 'payment_total', value: TextUtils.onlyNumber(e.target.value) } })}
                        name={'payment_total'} type={'text'} className="form-control" 
                        value={type === 'view' && !data?.payment_total ? '---': data?.payment_total}
                        placeholder={(type=='view' && !data?.payment_total) ? "---" : "Nhập số lượng..."} thousandSeparator={true} 
                    />
                </FormGroup>
            </div>
            {!onlyView &&
            <div className='payment-item-action'>
                <div style={{display:'flex', flexDirection: 'column'}}>
                    {!data?.id && <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>}
                    {detail?.length == detailIndex+1 && <Button onClick={handleAddData} className='nutri-square mt-2' color='success'><i className='uil-plus'></i></Button>}
                </div>
            </div>}
        </div>
    )
}

const History = (props:any)=>{
    const {history} = props
    
    const HistoryItem = ({item, itemOld}:any)=>{
        if(!itemOld){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : item?.updated_time ?  moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.created_uid?.name || item?.updated_uid?.name}</td>
                    <td>Tạo phiếu: {TextUtils.getLabelByValue(StatusList, item?.status)}</td>
                </tr>
            )
        }else if(item?.updated_uid && item?.status !== itemOld?.status){
            return(
                <tr>
                    <td>{item?.updated_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Thay đổi trạng thái: {TextUtils.getLabelByValue(StatusList, item?.status)}</td>
                </tr>
            )
        }else if(item?.updated_uid){
            return(
                <tr>
                    <td>{item?.updated_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Chỉnh sửa thông tin</td>
                </tr>
            )
        }
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : item?.updated_time ?  moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name || item?.updated_uid?.name}</td>
                <td>Tạo phiếu</td>
            </tr>
        )
    }


    return(
        <PageBody>
            <div className="nutri-title mb-3">Lịch sử thao tác</div>
            <div className="table-responsive" style={{overflow: 'unset'}}>
                <table className="mb-0 table-custom no-bg table table-input" >
                    <thead>
                        <tr>
                            <th style={{ width: '30%' }}>Thời gian</th>
                            <th style={{ width: '30%' }}>Người thực hiện</th>
                            <th style={{ width: '30%' }}>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        history?.map((item:any, index:number) => (
                            <HistoryItem 
                                item={item}
                                itemOld={history && history[index-1]}
                            />
                        ))
                    }
                    </tbody>
                </table>
            </div>
            
        </PageBody>
    )
}

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
      }),
  };

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
const ValueTextLabel = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    flex: 2;
`
const ValueTextValue = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    flex: 3;
`
const ValueTextTotal = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #EDA119;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    margin-left: 20px;
`
const ValueTextTotalPayment = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #FD4858;
    margin-left: 20px;
`

export default connect(mapState)(Detail)